<template>
    <div class="blurCapFeed">
        <BlurCapImage class="blurCapItem"
            v-for="(post, index) in posts"
            :key="index"
            :routerLink="'/post/' + post.slug"
            :image="post.cover"
            orientation="portrait">
                <RegularPost
                    :post="post"/>
        </BlurCapImage>
    </div>
</template>

<script>
    import RegularPost from '@/components/blog/main/RegularPost'

    export default {
        name: 'PostFeed',
        components: {
            RegularPost
        },
        props: {
            posts: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

</style>